import React from 'react'
import getId from '../utils/generateId'
import NumberInput from './NumberInput'
import styles from './RoughnessCoef.module.css'
import styles2 from './s.module.css'

class RoughnessCoef extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      value: this.props.defaultValue,
      index: 1,
      noOwnIndex: true,
      ownValue: 1
    }
    this.handleChange = this.handleChange.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
  }

  handleChange (e) {
    const value = Number(e.target.value)
    const i = Number(e.target.id.substring(5, 6))
    this.setState({
      value: value,
      index: i,
      noOwnIndex: i !== 2
    })
    this.props.onChange(value)
  }

  handleInputChange (e) {
    const value = Number(e)
    if (value === this.state.value) {
      return
    }
    this.setState({
      value: value,
      ownValue: value
    })
    this.props.onChange(value)
  }

  render () {
    const { index, noOwnIndex, ownValue } = this.state
    const rdName = getId()
    return (
      <div className={styles2.dimItemContainer}>
        <label>hydraulická drsnost potrubí k [mm]</label>
        <div className={styles.rcInputsContainer}>
          <label>
            <input type='radio' name={rdName} value={1.5} id='rc-i-1' checked={index === 1}
              onChange={this.handleChange} />
            <span>provozní drsnost dle doporučení ČSN 75 6101 k = 1,5</span>
          </label>
          <label>
            <input type='radio' name={rdName} value={ownValue} id='rc-i-2' checked={index === 2}
              onChange={this.handleChange} />
            <span>vlastní drsnost k = &nbsp;
              <NumberInput disabled={noOwnIndex} value={ownValue} onChange={this.handleInputChange}
                className={styles.rcIntup} active={index === 2} /></span>
          </label>
        </div>
      </div>
    )
  }
}

// RoughnessCoef.propTypes = {
//   defaultValue: PropTypes.number,
//   onChange: PropTypes.func,
//   manual: PropTypes.bool
// }

export default RoughnessCoef
